import Swiper from './../imports/import-swiper';


export default ()=>{
  const container = document.querySelector('.greeting__slider');
  if (container) {
    const slides = container.querySelectorAll(".swiper-slide");
    slides.length > 1 ? runSliderSwipe(): false;
  }
  

  function runSliderSwipe(){
    const slider = new Swiper(container, {
      speed: 500,
      effect: 'fade',
      touchStartPreventDefault: false,
      allowTouchMove: true,
      loop: true,
      fadeEffect: {
        crossFade: true
      },
      autoplay: {
          delay: 10000,
      },
      pagination:{
        el: '.greeting__slider-pagination',
        type: 'bullets',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '"><span></span></span>';
        }
      }
    });
  }
}
